//	T Y P E S

import { type___cookies___accepted } from "./types/types.cookies";
import { type___locale___language } from "./types/types.locale";

//	S T A T E

export interface state___App {

	app___isLoading: boolean,

	me___isLogged: boolean | null,
	me___isLogged___props: any | null,

	entry___language_selected: type___locale___language | null,
	entry___cookies_accepted: type___cookies___accepted | null,

	ionModal___MdEntryCookiesModal___isOpen: boolean,
	ionModal___MdEntryLanguageModal___isOpen: boolean,
	ionModal___MdSignPasswordChangeModal___isOpen: boolean,

}

//	S T A T E   D E F A U L T S

export const state___App___default: state___App = {

	app___isLoading: true,

	me___isLogged : null,
	me___isLogged___props : null,

	entry___language_selected: null,
	entry___cookies_accepted: null,

	ionModal___MdEntryCookiesModal___isOpen: false,
	ionModal___MdEntryLanguageModal___isOpen: false,
	ionModal___MdSignPasswordChangeModal___isOpen: false,

}